import {
  Component,
  computed,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-project-profile-card',
  templateUrl: './project-profile-card.component.html',
  styleUrls: ['./project-profile-card.component.scss'],
  standalone: false,
})
export class ProjectProfileCardComponent implements OnInit {
  // Inputs
  projectName = input<string>('');
  projectDescription = input<string>('');
  backgroundImage = input<string | undefined>(undefined);
  resolvedCoverPhoto = computed(() => this.backgroundImage() ||
    'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png');
  status = input<string>('');
  isHelpCard = input<boolean>(false);

  // Translation key inputs
  activeActionKey = input<string>(
    'home.complete_charity_profile.go_project_page'
  );
  draftActionKey = input<string>(
    'home.setup_profile.complete_project_profile'
  );
  setupTitleKey = input<string>('home.setup_profile.no_active_project');
  setupSubtitleKey = input<string>('home.setup_profile.start_fundraising');
  setupMessageKey = input<string>('home.setup_profile.no_projects_yet');
  setupActionKey = input<string>(
    'home.setup_profile.create_first_project'
  );
  helpTitleKey = input<string>('home.setup_profile.need_help');
  helpMessageKey = input<string>('home.setup_profile.help_learn_more');
  helpActionKey = input<string>('home.setup_profile.get_help');

  /**
   * SVG string for the create project icon displayed in setup state.
   * Defaults to a placeholder. Replace with actual SVG string.
   */
  createProjectIcon = input<string>(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 5V15M5 10H15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`);

  /**
   * SVG string for the help icon displayed in help state.
   * Defaults to a placeholder. Replace with actual SVG string.
   */
  helpIcon = input<string>(`<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M10.7792 17.3333C11.1583 17.3333 11.479 17.2022 11.7412 16.9401C12.0033 16.6779 12.1341 16.3576 12.1333 15.9792C12.1326 15.6007 12.0019 15.2801 11.7412 15.0172C11.4804 14.7543 11.1598 14.6236 10.7792 14.625C10.3986 14.6264 10.0783 14.7575 9.81825 15.0183C9.55825 15.279 9.42717 15.5993 9.425 15.9792C9.42283 16.3591 9.55392 16.6797 9.81825 16.9412C10.0826 17.2026 10.4029 17.3333 10.7792 17.3333ZM10.8333 21.6667C9.33472 21.6667 7.92639 21.3821 6.60834 20.813C5.29028 20.2439 4.14375 19.4722 3.16875 18.4979C2.19375 17.5236 1.42206 16.3771 0.853668 15.0583C0.285279 13.7396 0.000723594 12.3312 1.37131e-06 10.8333C-0.000720851 9.33544 0.283835 7.92711 0.853668 6.60833C1.4235 5.28956 2.1952 4.14303 3.16875 3.16875C4.14231 2.19447 5.28884 1.42278 6.60834 0.853667C7.92784 0.284556 9.33617 0 10.8333 0C12.3305 0 13.7388 0.284556 15.0583 0.853667C16.3778 1.42278 17.5244 2.19447 18.4979 3.16875C19.4715 4.14303 20.2435 5.28956 20.8141 6.60833C21.3846 7.92711 21.6688 9.33544 21.6667 10.8333C21.6645 12.3312 21.3799 13.7396 20.813 15.0583C20.2461 16.3771 19.4744 17.5236 18.4979 18.4979C17.5215 19.4722 16.3749 20.2442 15.0583 20.8141C13.7417 21.3839 12.3334 21.6681 10.8333 21.6667ZM10.8333 19.5C13.2528 19.5 15.3021 18.6604 16.9813 16.9812C18.6604 15.3021 19.5 13.2528 19.5 10.8333C19.5 8.41389 18.6604 6.36458 16.9813 4.68542C15.3021 3.00625 13.2528 2.16667 10.8333 2.16667C8.41389 2.16667 6.36458 3.00625 4.68542 4.68542C3.00625 6.36458 2.16667 8.41389 2.16667 10.8333C2.16667 13.2528 3.00625 15.3021 4.68542 16.9812C6.36458 18.6604 8.41389 19.5 10.8333 19.5ZM10.9417 6.175C11.3931 6.175 11.7859 6.31945 12.1203 6.60833C12.4547 6.89722 12.6216 7.25833 12.6208 7.69167C12.6208 8.08889 12.4991 8.44097 12.2558 8.74792C12.0124 9.05486 11.7368 9.34375 11.4292 9.61458C11.0139 9.97569 10.6484 10.3729 10.3328 10.8063C10.0172 11.2396 9.85906 11.7271 9.85834 12.2688C9.85834 12.5215 9.95331 12.7339 10.1433 12.9058C10.3332 13.0776 10.5542 13.1632 10.8063 13.1625C11.0771 13.1625 11.3075 13.0722 11.4974 12.8917C11.6874 12.7111 11.8091 12.4854 11.8625 12.2146C11.9347 11.8354 12.0972 11.4971 12.35 11.1995C12.6028 10.9019 12.8736 10.6174 13.1625 10.3458C13.5778 9.94861 13.9346 9.51528 14.2328 9.04583C14.5311 8.57639 14.6799 8.05278 14.6792 7.475C14.6792 6.55417 14.3047 5.80053 13.5558 5.21408C12.8068 4.62764 11.9354 4.33406 10.9417 4.33333C10.2556 4.33333 9.60122 4.47778 8.97867 4.76667C8.35611 5.05556 7.88197 5.49792 7.55625 6.09375C7.42986 6.31042 7.38942 6.54081 7.43492 6.78492C7.48042 7.02903 7.60211 7.21392 7.8 7.33958C8.05278 7.48403 8.31459 7.52917 8.58542 7.475C8.85625 7.42083 9.08195 7.26736 9.2625 7.01458C9.46111 6.74375 9.70956 6.53611 10.0078 6.39167C10.3061 6.24722 10.6174 6.175 10.9417 6.175Z" fill="black"/>
</svg>`);

  // Output
  buttonClicked = output<void>();

  // Computed properties
  hasProject = computed(() => !!this.status());
  isSetupState = computed(() => !this.hasProject() && !this.isHelpCard());
  isHelpState = computed(() => this.isHelpCard());
  showStatus = computed(() => this.hasProject());
  isDraftState = computed(() => this.status() === 'DRAFT');
  buttonTextKey = computed(() =>
    this.isDraftState() ? this.draftActionKey() : this.activeActionKey()
  );

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  // Methods
  onButtonClick(): void {
    this.buttonClicked.emit();
  }

  /**
   * Returns sanitized HTML for the icon SVG.
   * This bypasses Angular's default sanitization to allow SVG rendering.
   */
  getSafeIcon(): SafeHtml {
    const iconValue = this.isHelpState() ? this.helpIcon() : this.createProjectIcon();
    return this.sanitizer.bypassSecurityTrustHtml(iconValue || '');
  }
}
